(function (m, $) {

    let boundary, latlngbounds;
    let mapDefaultZoom = 13;
    let mapIsInitialised = false;
    m.init = function () {
        let observer = new IntersectionObserver(function(entries) {
            if(entries[0].isIntersecting === true && !mapIsInitialised)
                m.loadMap();
        }, { threshold: [0.01] });

        observer.observe(document.querySelector(".ux-map-section"));
    };
    
    m.loadMap = function() {
        var mapData = m.getData("data-deliverymap");
        var mapElement = document.getElementById("delivery-map");
        $(mapElement).css("height", $(mapElement).width() * 0.5);

        latlngbounds = new google.maps.LatLngBounds();

        var boundaryPoints = [];
        for (var i = 0; i < mapData.boundary_points.length; i++) {
            var newBoundaryPoint = new google.maps.LatLng(mapData.boundary_points[i][0], mapData.boundary_points[i][1]);
            boundaryPoints.push(newBoundaryPoint);
            latlngbounds.extend(newBoundaryPoint);
        }

        var dropSites = [];
        for (var j = 0; j < mapData.drop_sites.length; j++) {
            var newDropPoint = new google.maps.LatLng(mapData.drop_sites[j][0], mapData.drop_sites[j][1]);
            dropSites.push(newDropPoint);
            latlngbounds.extend(newDropPoint);
        }

        var styles = [
            {
                "featureType": "landscape.man_made",
                "stylers": [
                    { "visibility": "off" }
                ]
            }, {
                "featureType": "administrative.land_parcel",
                "stylers": [
                    { "visibility": "off" }
                ]
            }, {
                "featureType": "poi.business",
                "stylers": [
                    { "visibility": "off" }
                ]
            }, {

            }
        ];

        var mapOptions = {
            zoom: mapDefaultZoom,
            center: latlngbounds.getCenter(),
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            scrollwheel: false
        };

        var map = new google.maps.Map(mapElement, mapOptions);
        map.setOptions({ styles: styles });
        if (boundaryPoints.length > 0 || dropSites.length > 1) {
            map.fitBounds(latlngbounds);
        } else {
            map.setCenter(latlngbounds.getCenter());
            map.setZoom(mapDefaultZoom);
        }

        if (boundaryPoints.length > 0) {
            boundary = new google.maps.Polygon({
                paths: boundaryPoints,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                clickable: false
            });

            boundary.setMap(map);
        }

        if (dropSites.length > 0) {
            for (var k = 0; k < mapData.drop_sites.length; k++) {
                new google.maps.Marker({
                    position: dropSites[k],
                    map: map,
                    icon: ooooby.createGoogleMapsMarkerIcon("/Content/images/marker-ooooby-dark.png")
                });
            }
        }

        google.maps.event.addDomListener(window, "resize", function () {
            var mapHeight = $(mapElement).width() * 0.5;
            if (mapHeight < 260)
                mapHeight = 260;
            $(mapElement).css("height", mapHeight);
            google.maps.event.trigger(map, "resize");
            
            if (boundaryPoints.length > 0 || dropSites.length > 1) {
                map.fitBounds(latlngbounds);
            } else {
                map.setCenter(latlngbounds.getCenter());
                map.setZoom(mapDefaultZoom);
            }
        });

        google.maps.event.addListener(map, "zoom_changed", function () {
            if (map.getZoom() > 16) map.setZoom(16);
        });

        mapIsInitialised = true;
    };

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function() {
    ooooby.init();
});